import axios from 'axios';
import DataHookData = App.Sms.Data.DataHookData;

export async function index(): Promise<{ hooks: DataHookData[] }> {
  return axios.get(route('api.sms.data-hooks.index')).then((res) => res.data);
}
